import React, { useEffect } from "react";
import { createContext, useState, useContext } from "react";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { BASE_URL } from "../App";
import { deleteCookie } from "../components/Common/Utils";
import { useNavigate } from "react-router-dom";
import { showNotyError } from "../components/Common/notificationUtils";

// import { isSessionExpired } from '../Componets/Common/Utils'

// import axios from 'axios'
// import { ADMIN, TEAM_ADMIN } from '../Componets/Common/StaticDatas'

type AuthContextProps = {
  children: React.ReactNode;
};
type userTypeProps = {
  name: string;
  unique_name: string;
  role: String;
};
type Authype = {
  user: userTypeProps;
  login: any;
};

function getCookie(name: string) {
  return (
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || ""
  );
}

const AuthContext = createContext<Authype | any>(null);
export const AuthProvider = ({ children }: AuthContextProps) => {
  const token = getCookie("detection_auth");
  const [activeButton, setActiveButton] = useState("upload");
  const LoggedInUser: any = {};
  const [loading, setLoading] = useState(true); // Add loading state
  const [user, setUser] = useState<any>(LoggedInUser || {});
  const navigate = useNavigate();
  // useEffect(() => {
  //   if (token) {
  //     try {
  //       const LoggedInUser: any = jwt_decode(token);
  //       getUserRole(LoggedInUser.email).then((res) => {
  //         let data = {
  //           ...LoggedInUser,
  //           fullName: user.given_name + " " + user.family_name,
  //           id: res.id,
  //           isAdmin: res.isAdmin,
  //           email: res.emailAddress,
  //         };
  //         setUser(data);
  //       });
  //     } catch (error) {
  //       console.error("Invalid token: ", error);
  //     }
  //   } else {
  //     console.log("No token found");

  //   }
  // }, []);

  useEffect(() => {
    const token = getCookie("detection_auth");
    if (token) {
      try {
        const decoded: any = jwt_decode(token);
        getUserRole(decoded.email)
          .then((res) => {
            if (res) {
              let modifiedUserData = {
                ...res,
                fullName: res.given_name + " " + res.family_name,
                id: res.id,
                isAdmin: res.isAdmin,
                email: res.emailAddress,
              };

              setUser({ ...decoded, ...modifiedUserData });
            } else {
              setUser(null);
              deleteCookie("detection_auth");
              showNotyError("Login failed. Please try again");
              navigate("/login");
            }
          })
          .catch(() => setUser(null))
          .finally(() => setLoading(false));
      } catch (error) {
        setUser(null);
        setLoading(false);
      }
    } else {
      setUser(null);
      setLoading(false);
    }
  }, []);

  const getUserRole = (email) => {
    return axios
      .get(BASE_URL + `users/email/${email}`, {
        headers: {
          detection_auth: getCookie("detection_auth"),
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return false;
      });
  };

  // "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ikg5bmo1QU9Tc3dNcGhnMVNGeDdqYVYtbEI5dyJ9.eyJhdWQiOiI2MmUwMTRlOC1iNTE5LTQxZWYtYWFiNC0xODE5Y2JhY2NkYzUiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vYmJjYjZiMmYtOGM3Yy00ZTI0LTg2ZTQtNmMzNmZlZDAwYjc4L3YyLjAiLCJpYXQiOjE3MjY3MjIxNTYsIm5iZiI6MTcyNjcyMjE1NiwiZXhwIjoxNzI2NzI3MTk5LCJhaW8iOiJBVVFBdS84WEFBQUE1WWk5cW5PMlNBZEJrazZjNGJGYk5hVEdpR0Uxb24vb1FlRGlUaERxSzZ6OEQyT3FNMkRIZFFUU0I0MUdmcEYzK3FQZStsY3lDOXo2QnNpemY5UGV2dz09IiwiYXpwIjoiNjJlMDE0ZTgtYjUxOS00MWVmLWFhYjQtMTgxOWNiYWNjZGM1IiwiYXpwYWNyIjoiMSIsIm5hbWUiOiJQZXJpeWFzYW15LCBWaW5vdGgiLCJvaWQiOiI5Y2E2OTQwMy0yZTY3LTQ1YWItODIzMi01ZjY0MTBhNDYzOWYiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJ2aW5vdGgucGVyaXlhc2FteUB1bXVzaWMuY29tIiwicmgiOiIwLkFRa0FMMnZMdTN5TUpFNkc1R3cyX3RBTGVPZ1U0R0ladGU5QnFyUVlHY3VzemNVSkFGTS4iLCJzY3AiOiJ1c2VyX2ltcGVyc29uYXRpb24iLCJzdWIiOiJ1RllJSnBCS2p4VkZjQllXTjhfazB6QWgzLV9RSXd5RC1JZ1FQYmNvNVQ4IiwidGlkIjoiYmJjYjZiMmYtOGM3Yy00ZTI0LTg2ZTQtNmMzNmZlZDAwYjc4IiwidXRpIjoiMkhNZFZ6U05DMENvNlZBdUJjY0FBQSIsInZlciI6IjIuMCJ9.S166--PVuofUvRpBqbd_AcKi6oBgMl8Q5KFHqssTj5qxcHRRPbVf1m26L9vF9330QE3EF_Zl7_8xTnT62Apwq2ZaU42slP_IbdcZfwAeFjlR4fU-Vup8P60PhuOFuVVLVX4WE2gtFbOhBLatah5a7U6piieOl80vOkSHgAEKGiBDBnUnPzxi1KgWzoYMrs-i7WZSH_RQUfObOUvV0f46NNyXwlVfHAfvaUxdtIyEcECGGOKBSp-nPSaOX9t4_c6h33UvnyafFGMW3JYgUNJOJ2kUY8adnJhoTlbq1alJ6uHi7tbMvdsu4fKAQaf-N6xzXJyvcYLeNEbabZnrJc-LDg";
  // let LoggedInUser: any = jwt_decode(token);

  const [darkMode, setDarkMode] = useState<boolean>(true);
  const [updatedRole, setUpdatedRole] = useState<boolean>(false);
  const [notifyCount, setNotifyCount] = useState<number>(0);
  const [current, setCurrent] = useState("");
  const [emailLookUps, setEmailLookUps] = useState([]);

  // const getUserRole = () => {
  //   return axios
  //     .get(BASE_URL + 'User/GetUser', {
  //       headers: {
  //         cpr_portal: token,
  //       },
  //     })
  //     .then((res) => {
  //       return res.data
  //     })
  //     .catch((err) => {
  //       return false
  //     })
  // }

  // React.useEffect(() => {
  //   Promise.all([getUserRole(), getEmailLookUps()])
  //     .then(([data1, data2]) => {
  //       if (data1 && data1.length > 0) {
  //         setUser({
  //           ...user,
  //           role: data1[0].masterRole,
  //           name: data1[0].members[0].userName,
  //           id: data1[0].members[0].userId,
  //           isAdmin: data1[0].masterRole == ADMIN || data1[0].masterRole == TEAM_ADMIN,
  //         })
  //         sessionStorage.setItem('userId', String(data1[0].members[0].userId))
  //         sessionStorage.setItem('isAdmin', String(data1[0].masterRole == ADMIN || data1[0].masterRole == TEAM_ADMIN))
  //       }
  //       const transformedMentionsList = data2.userList.emailLookUp.map(({ name }) => ({
  //         value: `${name.replace(' ', '')}`,
  //         label: name.toLowerCase(),
  //       }))
  //       setEmailLookUps(transformedMentionsList)
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching data:', error)
  //     })
  // }, [updatedRole])
  const login = (user: any) => {
    setUser(user);
  };
  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        activeButton,
        setActiveButton,
        darkMode,
        setDarkMode,
        loading,
        // updatedRole,
        // setUpdatedRole,
        // notifyCount,
        // setNotifyCount,
        // emailLookUps,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
